import "./AppPreviewDialogComponent.scss";
import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button.tsx";
import { ExternalLink } from "lucide-react";

interface AppPreviewDialogComponentProps {
    app: any;
    onClose: () => void;
}

const AppPreviewDialog = ({ app }: AppPreviewDialogComponentProps) => {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (app) {
            // Reset loading state when a new app is selected
            setIsLoading(true);
        }
    }, [app]);

    if (!app) return null;

    return (
        <div className="app-preview-dialog">
            <div className="dialog-layout">
                {/* Left Panel - App Preview */}
                <div className="preview-panel">
                    <div className="app-preview-container">
                        {isLoading && (
                            <div className="app-preview-loading">
                                <div className="loading-spinner"></div>
                                <p>Loading application...</p>
                            </div>
                        )}
                        <iframe
                            src={app.url}
                            loading="lazy"
                            width="100%"
                            height="100%"
                            style={{ opacity: isLoading ? 0 : 1 }}
                            onLoad={() => setIsLoading(false)}
                        />
                    </div>
                </div>

                {/* Right Panel - App Information */}
                <div className="info-panel">
                    <div className="app-info-header">
                        <h1 className="app-title">{app.name}</h1>
                       
                    </div>

                    <div className="app-actions">
                        <Button 
                            variant="white" 
                            onClick={() => {
                                window.open(app.url, "_blank");
                            }}
                            fullWidth={false}
                        >
                            <ExternalLink className="button-icon" />
                            View App
                        </Button>
                    </div>

                    <div className="app-categories">
                        {app.tags && app.tags.map((tag: string, index: number) => (
                            <span key={index} className="category-tag">{tag}</span>
                        ))}
                    </div>

                    <div className="app-description">
                        <p>{app.description}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AppPreviewDialog;
